/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';
import classNames from 'classnames';
import "./TreeItem.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TreeItem(props) {
  var _props$clone = props.clone,
    clone = _props$clone === void 0 ? false : _props$clone,
    depth = props.depth,
    _props$withDepthMarke = props.withDepthMarkers,
    withDepthMarkers = _props$withDepthMarke === void 0 ? true : _props$withDepthMarke,
    _props$disableInterac = props.disableInteraction,
    disableInteraction = _props$disableInterac === void 0 ? false : _props$disableInterac,
    _props$ghost = props.ghost,
    ghost = _props$ghost === void 0 ? false : _props$ghost,
    handleProps = props.handleProps,
    value = props.value,
    _props$dragRef = props.dragRef,
    dragRef = _props$dragRef === void 0 ? null : _props$dragRef,
    _props$wrapperRef = props.wrapperRef,
    wrapperRef = _props$wrapperRef === void 0 ? null : _props$wrapperRef,
    renderItem = props.renderItem,
    item = props.item,
    style = props.style,
    top = props.top;
  var depthMarkers = useMemo(() => withDepthMarkers ? Array(depth).fill(0).map((_, i) => /*#__PURE__*/_jsx("span", {
    className: "depth-line",
    style: style
  }, "depth-line-".concat(i))) : null, [depth, style, withDepthMarkers]);
  var renderItemProps = useMemo(() => ({
    ref: dragRef,
    clone,
    value,
    item,
    handleProps
  }), [dragRef, clone, value, item, handleProps]);
  var wrapperStyle = useMemo(() => ({
    top,
    position: 'absolute'
  }), [top]);
  return /*#__PURE__*/_jsxs("li", {
    className: classNames('item-wrapper', {
      clone,
      ghost,
      disableInteraction
    }),
    "data-id": item.id,
    "data-index": item.index,
    ref: wrapperRef,
    style: wrapperStyle,
    children: [!clone && withDepthMarkers && depthMarkers, renderItem(renderItemProps)]
  }, value);
}
TreeItem.displayName = 'TreeItem';
//# sourceMappingURL=TreeItem.js.map